import ImageModel from "../models/ImageModel";

export default class SignatureValid{
    public static checkSignature(data: ImageModel, errorMsg: string, admin: boolean){

        var countMillCertFileTypeNotMatch: number = 0;
        var countStockistCertFileTypeNotMatch: number = 0;

        if(!admin){
            //if(data.signature === undefined || data.signature === null){
            //    errorMsg = errorMsg + "Signature must not be empty! \n簽名不能為空！ \n"
            //}
            if(data.MillCert !== undefined){
                data.MillCertDocType?.forEach((MillCertDocType)=>{
                    if(!MillCertDocType.includes("zip") && MillCertDocType !== "pdf" && MillCertDocType !== ""){
                        countMillCertFileTypeNotMatch += 1;
                    }
                }) 
            }
            
            if(countMillCertFileTypeNotMatch > 0){
                errorMsg = errorMsg + "MillCert Doc Type must be zip or pdf! \n工廠證書文件類型必須是 zip 或 pdf！ \n"
            }

            if(data.StockistCert !== undefined){
                data.StockistCertDocType?.forEach((StockistCertDocType)=>{
                    if(!StockistCertDocType.includes("zip") && StockistCertDocType !== "pdf" && StockistCertDocType !== ""){
                        countStockistCertFileTypeNotMatch += 1;
                    }
                }) 
            }
            
            if(countStockistCertFileTypeNotMatch > 0){
                errorMsg = errorMsg + "StockistCert Doc Type must be zip or pdf! \n供應商證書文件類型必須是 zip 或 pdf！ \n"
            }
        }
        if(admin){
            if(data.signatureSteel === undefined || data.signatureSteel === null){
                errorMsg = errorMsg + "Steel Laboratory Test Signature must not be empty! \nSteel Laboratory Test 簽名不能為空！ \n"
            }
            if(data.signatureChemistry === undefined || data.signatureChemistry === null){
                errorMsg = errorMsg + "Chemistry Laboratory Test Signature must not be empty! \nChemistry Laboratory Test 簽名不能為空！ \n"
            }
        }
        return errorMsg
    }
}